"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Hammer = function Hammer(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M20.606 11.6l-1.518 1.517a.469.469 0 01-.662 0l-.63-.629a.45.45 0 01-.114-.393 1.26 1.26 0 00-.46-1.064c-.488-.488-1.002-.606-1.246-.362l-.53.53a.625.625 0 01-.883 0l-1.768-1.767a.625.625 0 010-.883l.933-.932a.304.304 0 00-.002-.428c-1.205-1.234-2.61-.86-3.667-.231a.316.316 0 01-.361-.049l-.136-.136a.238.238 0 01.005-.337c1.514-1.514 4.724-1.81 6.16-.375l2.217 2.217a.45.45 0 01.114.393 1.26 1.26 0 00.46 1.064c.26.317.657.489 1.065.46a.45.45 0 01.393.114l.63.63a.468.468 0 010 .662zm-7.92-1.337l1.052 1.052c.183.183.186.48.007.667L7.53 18.477a1.273 1.273 0 01-1.819.02l-.21-.21a1.272 1.272 0 01.02-1.818l6.498-6.213a.477.477 0 01.667.007z"
  }));
};

var _default = (0, _react.forwardRef)(Hammer);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Hammer, "Hammer", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Hammer.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Hammer.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9IYW1tZXIudHN4Il0sIm5hbWVzIjpbIkhhbW1lciIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxNQUFzRSxHQUFHLFNBQXpFQSxNQUF5RSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUM3RTtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQUQ2RTtBQUFBLENBQS9FOztlQVNlLHVCQUFXRixNQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLE0iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEhhbW1lcjogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMjAuNjA2IDExLjZsLTEuNTE4IDEuNTE3YS40NjkuNDY5IDAgMDEtLjY2MiAwbC0uNjMtLjYyOWEuNDUuNDUgMCAwMS0uMTE0LS4zOTMgMS4yNiAxLjI2IDAgMDAtLjQ2LTEuMDY0Yy0uNDg4LS40ODgtMS4wMDItLjYwNi0xLjI0Ni0uMzYybC0uNTMuNTNhLjYyNS42MjUgMCAwMS0uODgzIDBsLTEuNzY4LTEuNzY3YS42MjUuNjI1IDAgMDEwLS44ODNsLjkzMy0uOTMyYS4zMDQuMzA0IDAgMDAtLjAwMi0uNDI4Yy0xLjIwNS0xLjIzNC0yLjYxLS44Ni0zLjY2Ny0uMjMxYS4zMTYuMzE2IDAgMDEtLjM2MS0uMDQ5bC0uMTM2LS4xMzZhLjIzOC4yMzggMCAwMS4wMDUtLjMzN2MxLjUxNC0xLjUxNCA0LjcyNC0xLjgxIDYuMTYtLjM3NWwyLjIxNyAyLjIxN2EuNDUuNDUgMCAwMS4xMTQuMzkzIDEuMjYgMS4yNiAwIDAwLjQ2IDEuMDY0Yy4yNi4zMTcuNjU3LjQ4OSAxLjA2NS40NmEuNDUuNDUgMCAwMS4zOTMuMTE0bC42My42M2EuNDY4LjQ2OCAwIDAxMCAuNjYyem0tNy45Mi0xLjMzN2wxLjA1MiAxLjA1MmMuMTgzLjE4My4xODYuNDguMDA3LjY2N0w3LjUzIDE4LjQ3N2ExLjI3MyAxLjI3MyAwIDAxLTEuODE5LjAybC0uMjEtLjIxYTEuMjcyIDEuMjcyIDAgMDEuMDItMS44MThsNi40OTgtNi4yMTNhLjQ3Ny40NzcgMCAwMS42NjcuMDA3elwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKEhhbW1lcik7XG4iXX0=